import { render, staticRenderFns } from "./BudgetExpanse.vue?vue&type=template&id=6ba20188"
import script from "./BudgetExpanse.vue?vue&type=script&lang=js"
export * from "./BudgetExpanse.vue?vue&type=script&lang=js"
import style0 from "./BudgetExpanse.vue?vue&type=style&index=0&id=6ba20188&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports